import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

export type ConsentState = {
  necessary: true; // toujours vrai (strictement nécessaire)
  monitoring: boolean | null; // null = pas encore choisi
  updatedAt: string | null;
};

const KEY = 'privacy_consent_v1';

const defaultState: ConsentState = {
  necessary: true,
  monitoring: null,
  updatedAt: null,
};

function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

export async function loadConsent(): Promise<ConsentState> {
  try {
    if (isNative()) {
      const { value } = await Preferences.get({ key: KEY });
      if (!value) return defaultState;

      const parsed = JSON.parse(value) as ConsentState;
      return {
        necessary: true,
        monitoring: parsed.monitoring ?? null,
        updatedAt: parsed.updatedAt ?? null,
      };
    }

    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultState;

    const parsed = JSON.parse(raw) as ConsentState;
    return {
      necessary: true,
      monitoring: parsed.monitoring ?? null,
      updatedAt: parsed.updatedAt ?? null,
    };
  } catch {
    return defaultState;
  }
}

export async function saveConsent(next: ConsentState): Promise<void> {
  const value = JSON.stringify(next);

  if (isNative()) {
    await Preferences.set({ key: KEY, value });
    return;
  }

  localStorage.setItem(KEY, value);
}

export async function setMonitoringConsent(allowed: boolean): Promise<ConsentState> {
  const next: ConsentState = {
    necessary: true,
    monitoring: allowed,
    updatedAt: new Date().toISOString(),
  };
  await saveConsent(next);
  return next;
}

export async function resetConsent(): Promise<void> {
  if (isNative()) {
    await Preferences.remove({ key: KEY });
    return;
  }

  localStorage.removeItem(KEY);
}
